import { Link as ScrollLink } from 'react-scroll';
import { useLocation, Outlet } from 'react-router-dom';
// material
import { Box, Link, Container, Typography } from '@material-ui/core';
// components
import Logo from '../../components/Logo';
import MainNavbar from './MainNavbar';
import MainFooter from './MainFooter';

// ----------------------------------------------------------------------

export default function MainLayout() {
  const { pathname, search } = useLocation();
  const isHome = pathname === '/';
  const isSiteMap = pathname === '/site-map';
  const isEnquiry = pathname === '/skyniche-enquiry-details';
  const isBrochur = pathname === '/skyniche-indiamobilecongress-brochure';
  const isBrochurQR = pathname === '/brochure-qr-scanner';
  const isCompanyQR = pathname === '/company-profile-qr-scanner';
  const isEmployeeQR = pathname === '/employee-qr-scanner';
  const isEmployee = pathname.startsWith('/employee') && !isEmployeeQR;
  const isEditEmployeeModal = pathname === '/edit-employee' && search.includes('modal=true');

  return (
    <>
      {!isEnquiry && !isBrochur && !isEmployee && !isEmployeeQR && !isEditEmployeeModal && <MainNavbar />}
      
      <div>
        <Outlet />
      </div>

      {!isEnquiry && !isSiteMap && !isBrochur && !isBrochurQR && !isCompanyQR && !isEmployeeQR && !isEmployee && !isEditEmployeeModal && (
        <MainFooter />
      )}
    </>
  );
}
